import { BaseModel } from "sjs-base-model";

export default class DatiUtenteRichiestaCedibilitaModel extends BaseModel {
    public readonly nameIdentifier: string = "";
    public readonly email: string = "";
    public readonly givenName: string = "";
    public readonly surname: string = "";
    public readonly memberCode: number = 0;
    public readonly abi: string = "";

    constructor(data: Partial<DatiUtenteRichiestaCedibilitaModel>) {
        super();

        this.update(data);
    }
}
